<template>
<div>
    <label class="switch">
        <input type="checkbox" :checked="checked" @change="onChangeFunction">
        <span class="slider round"></span>
    </label>
</div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';


@Options({
    props: {
        onChangeFunction: Function,
        checked: {
            type: Boolean,
            default: false
        }
    },
    methods: {
    },
})
export default class ToggleSwitch extends Vue {
}
</script>

<style scoped>
/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 4vh;
  height: 1.3vh;
  padding: 0.5vh;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .1s;
  transition: .1s;
}

.slider:before {
  position: absolute;
  content: "";
  width: 1.3vh;
  height: 1.3vh;
  margin: 0.5vh;
  background-color: white;
  -webkit-transition: .1s;
  transition: .1s;
}

input:checked + .slider {
  background-color: #2196F3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(calc(2.7vh));
  -ms-transform: translateX(calc(2.7vh));
  transform: translateX(calc(2.7vh));
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
